
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.746 15.75h-7.5c-3 0-3.75-.75-3.75-3.75V6c0-3 .75-3.75 3.75-3.75h7.5c3 0 3.75.75 3.75 3.75v6c0 3-.75 3.75-3.75 3.75zM10.496 6h3.75M11.25 9h3M12.75 12h1.5","stroke":"#515952","stroke-width":"1.248","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.377 8.469a1.358 1.358 0 100-2.715 1.358 1.358 0 000 2.715zM9 12.248a2.265 2.265 0 00-2.055-2.04 5.79 5.79 0 00-1.14 0 2.272 2.272 0 00-2.055 2.04","stroke":"#515952","stroke-width":"1.248","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    